<!--  -->
<template>
    <div id='approveFlow'>
        <section>
            <h5>
                <div class="title">审批流程</div>
            </h5>
            <div v-for="(v,k) in detail.examineSequenceList" :key="k+'examineSequenceList'" :class="[{'unaudited':v.examineStatus==0||!v.examineStatus},{'isrefused':v.examineStatus==2}]">
                <div class="appHead">
                    <div class="head-icon" :class="{'returnColor':v.examineStatus==4||(detail.examineSequenceList&&detail.examineSequenceList[1].examineStatus==4&&!v.examineStatus)}">
                        <img v-if="v.sequence==0" class="icon-bg" src="../../../assets/img/applicant.png" alt="">
                        <img v-if="v.sequence!=0&&v.sequence!==999999999" class="icon-bg" src="../../../assets/img/approver.png" alt="">
                        <img v-if="v.sequence==999999999" class="icon-bg" src="../../../assets/img/cc.png" alt="">
                        <img v-if="v.examineStatus=='0'&&!v.isUnaudited" class="icon-status" src="../../../assets/img/approving.png" alt="">
                        <img v-if="v.examineStatus=='2'" class="icon-status" src="../../../assets/img/refuseApprove.png" alt="">
                        <img v-if="v.examineStatus=='3'" class="icon-status" src="../../../assets/img/isApproved.png" alt="">
                        <img v-if="(v.examineStatus=='0'||!v.examineStatus)&&v.isUnaudited" class="icon-status" src="../../../assets/img/unaudited.png" alt="">

                    </div>
                    <div class="headInfo" v-if="v.sequence==0||v.approveDetailList.length==1">
                        <div class="headTitle">
                            <h5>{{v.empName}}{{v.sequence==0?'（申请人）':''}}</h5>
                            <span>{{v.examineTime}}</span>
                        </div>
                        <div class="info-post">
                            <div><span>{{v.approveDetailList[0].departmentName}}</span><span>{{v.approveDetailList[0].position}}</span></div>
                        </div>
                    </div>
                    <div class="headInfoMutiple" v-if="(v.sequence!=0&&v.approveDetailList.length>1||v.sequence==999999999)">
                        <h5 v-if="v.sequence!=999999999">审批{{v.approveDetailList.length}}人</h5>
                        <h5 v-if="v.sequence==999999999">抄送{{v.approveDetailCcList.length}}人</h5>
                        <div class="info-post">
                            <span>{{v.examineTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="appMember">
                    <div>
                        <div v-for="(item,index) in v.approveDetailList" :key="index+'approveDetailList'">
                            <div class="member-info" v-if="v.approveDetailList.length>1">
                                <span class="head-icon" :class="{'returnColor':item.examineStatus==4}">{{item&&item.empName&&item.empName.slice(0,1)}}
                                    <img v-if="item.examineStatus=='0'&&!item.isUnaudited" class="icon-status" src="../../../assets/img/approving.png" alt="">
                                    <img v-if="item.examineStatus=='2'" class="icon-status" src="../../../assets/img/refuseApprove.png" alt="">
                                    <img v-if="item.examineStatus=='3'" class="icon-status" src="../../../assets/img/isApproved.png" alt="">
                                    <img v-if="item.examineStatus=='0'&&item.isUnaudited" class="icon-status" src="../../../assets/img/unaudited.png" alt="">
                                </span>
                                <div>
                                    <h5>{{item.empName}}</h5>
                                    <div class="info-post"><span>{{item.departmentName}}</span><span>{{item.position}}</span></div>
                                </div>
                            </div>
                            <div class="appStatus" v-if="item.remark">{{item.remark}}</div>
                        </div>
                        <div v-for="(item,index) in v.approveDetailCcList" :key="index+'approveDetailCcList'">
                            <template v-if="v.approveDetailCcList.length>0">
                                <div v-if="v.sequence!=999999999&&index==0" class="memberCc">抄送{{v.approveDetailCcList.length}}人</div>
                                <div class="member-info">
                                    <span class="head-icon" :class="{'returnColor':detail.examineSequenceList&&detail.examineSequenceList[1].examineStatus==4}">{{item&&item.empName&&item.empName.slice(0,1)}}
                                        <!-- <img v-if="item.examineStatus=='0'&&!item.isUnaudited" class="icon-status" src="../../../assets/img/approving.png" alt="">
                                        <img v-if="item.examineStatus=='2'" class="icon-status" src="../../../assets/img/refuseApprove.png" alt="">
                                        <img v-if="item.examineStatus=='3'" class="icon-status" src="../../../assets/img/isApproved.png" alt="">
                                        <img v-if="item.examineStatus=='0'&&item.isUnaudited" class="icon-status" src="../../../assets/img/unaudited.png" alt=""> -->
                                    </span>
                                    <div>
                                        <h5>{{item.empName}}</h5>
                                        <div class="info-post"><span>{{item.departmentName}}</span><span>{{item.position}}</span></div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        detail: {
            type: Object,
            default: () => { return {} }
        }
    },
    components: {},

    computed: {
        isUnaudited: () => {

        }
    },

    data() {
        return {
        };
    },

    mounted() {
    },

    methods: {}
}

</script>
<style lang='less' scoped>
#approveFlow {
    padding: 20px;
    section {
        padding: 20px;
        background: #ffffff;
        border-radius: 20px;
        > h5 {
            padding: 20px 0;
            border-bottom: 1px solid #ccc;
            margin: 0 0 20px 0;
        }
        > div {
            &:last-of-type {
                .appMember {
                    > div {
                        border: 0;
                    }
                }
            }
        }
        .title {
            padding-left: 20px;
            border-left: 10px solid #0c92f4;
        }
    }
    .appHead {
        display: flex;
        align-items: center;
        h5 {
            margin: 0;
        }
        .head-icon {
            width: 50px;
            height: 50px;
            background: #0c92f4;
            border-radius: 8px;
            position: relative;
            flex-shrink: 0;
            margin-right: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon-bg {
                width: 40px;
                height: 40px;
            }
            .icon-status {
                position: absolute;
                bottom: -5px;
                right: -5px;
                width: 25px;
                height: 25px;
                background: #fff;
                border-radius: 50%;
            }
        }
        .returnColor {
            background: #999999;
        }
        .headInfo {
            width: 100%;
            > .headTitle {
                display: flex;
                justify-content: space-between;
                span {
                    color: #999999;
                    font-size: 0.32rem;
                }
            }
            .info-post {
                color: #999999;
                font-size: 24px;
                display: flex;
                justify-content: space-between;
                > div {
                    span {
                        padding-right: 20px;
                    }
                }
            }
        }
        .headInfoMutiple {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .info-post {
                color: #999999;
                font-size: 24px;
            }
        }
    }
    .appMember {
        padding-left: 25px;
        margin: 10px 0;
        > div {
            padding-left: 45px;
            border-left: 2px dashed #ccc;
            min-height: 40px;
        }
        .member-info {
            display: flex;
            align-items: center;
            padding: 10px 0;
            h5 {
                margin: 0;
            }
            .head-icon {
                width: 50px;
                height: 50px;
                background: #0c92f4;
                border-radius: 8px;
                position: relative;
                flex-shrink: 0;
                margin-right: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-weight: bold;
                .icon-status {
                    position: absolute;
                    bottom: -5px;
                    right: -5px;
                    width: 25px;
                    height: 25px;
                    background: #fff;
                    border-radius: 50%;
                }
            }
            .returnColor {
                background: #999999;
            }
            .info-post {
                color: #999999;
                font-size: 24px;
                display: flex;
                justify-content: space-between;
                span {
                    padding-right: 20px;
                }
            }
        }
        .memberCc {
            font-size: 24px;
            font-weight: bold;
        }
        .appStatus {
            padding: 15px 10px;
            width: 100%;
            background: #f2f2f2;
            border-radius: 10px;
            margin-bottom: 20px;
        }
    }
    section .unaudited + .unaudited {
        color: #999999;
        .head-icon {
            background: #999999;
        }
    }
    section .isrefused + .unaudited {
        color: #999999;
        .head-icon {
            background: #999999;
        }
    }
}
</style>